// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isWednesday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isWednesday = convertToFP(fn, 1);
export default isWednesday;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isWednesday/index.js
// module id = 945
// module chunks = 0